import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import ContentExample from '../examples/Content';
import ContentBlockWithShadowExample from '../examples/ContentBlockWithShadow';
import ContentBlockWithFooterExample from '../examples/ContentBlockWithFooter';
const ContentExampleSource = require('!!raw-loader!../examples/Content');
const ContentBlockWithShadowExampleSource = require('!!raw-loader!../examples/ContentBlockWithShadow');
const ContentBlockWithFooterExampleSource = require('!!raw-loader!../examples/ContentBlockWithFooter');
export default class ContentPage extends React.Component {
    render() {
        return (<div>
                <Helmet title="Content"/>
                <h3>ContentBlock</h3>
                <div className="docs-example docs-example--dark">
                    <ContentExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{ContentExampleSource}</PrismCode>
                </pre>
                <div>
                    <h4>ContentBlock Properties</h4>
                    <pre>
                        <PrismCode className="language-jsx">
                            {`type Props = {|
  className: string,
  children: Node,
  shadow: boolean,
|};`}
                        </PrismCode>
                    </pre>
                </div>
                <h3>ContentBlock with Shadow</h3>
                <div className="docs-example">
                    <ContentBlockWithShadowExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{ContentBlockWithShadowExampleSource}</PrismCode>
                </pre>
                <h3>ContentBlock with footer</h3>
                <div className="docs-example docs-example--dark">
                    <ContentBlockWithFooterExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{ContentBlockWithFooterExampleSource}</PrismCode>
                </pre>
            </div>);
    }
}
